import { AccessType } from 'app/auth/accessControlService'
import Subscribers from './Subscribers'
import SubscribersPage from './SubscribersPage'
import SubscriberDetail from 'app/main/subscribersV4/subscriberDetail/SubscriberDetail'
import { Routes } from 'app/services/routeService/routeService'
import ImportSubscribers from './ImportSubscribers'

export default {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
        footer: {
          display: false,
        },
      },
    },
  },

  routes: [
    {
      path: Routes.subscribersV4(),
      component: SubscribersPage,
      accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
      routes: [
        {
          exact: true,
          path: Routes.subscribersV4(),
          component: Subscribers,
        },
        {
          exact: true,
          path: Routes.importSubscriberV4(),
          component: ImportSubscribers,
        },
        {
          exact: true,
          path: Routes.subscribersV4Detail(),
          component: SubscriberDetail,
        },
      ],
    },
  ],
}
